import { render } from "./ModalNuovaRichiesta.vue?vue&type=template&id=6bea36ec&scoped=true"
import script from "./ModalNuovaRichiesta.vue?vue&type=script&lang=js"
export * from "./ModalNuovaRichiesta.vue?vue&type=script&lang=js"

import "./ModalNuovaRichiesta.vue?vue&type=style&index=0&id=6bea36ec&scoped=true&lang=css"

import exportComponent from "/Users/andrea/Sites/app_v2/app_ecocomfort/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6bea36ec"]])

export default __exports__